import React from "react";
import { Formik, Form as FormikForm } from "formik";
import cx from "classnames";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { digitRegExp } from "../../../../constants";
import { ErrorMessage } from "../../../../components/Notifications";
import { SubmitButton } from "../../../../components/Buttons/SubmitButton";
import { SectionTitleWithInfo } from "../../../../components/SectionTitleWithInfo";
import { Input } from "../Input";
import { MAX_NUMBER_VALIDATION_ERRORS, MAX_ATTEMPT_ALLOWED } from "../../constants";

import { Footer } from "../../../../components/Footer";
import { StyledOTPForm } from "./styled";
import { ConfirmDialog } from "../../../../components/Modals";
import routes from "../../../../routes";
import { getIsIslamicBanking } from "../../../../store/selectors/appConfig";

export const Form = ({
  attempts, // OTP verification attempts
  loginAttempt, // number ot resend
  isPending,
  isGenerating,
  verificationError,
  code,
  otpRef,
  setCode,
  submitForm,
  handleSendNewCodeLinkClick,
  info,
  title,
  otpType,
  maxServerAttemptsExceeded,
  heading
}) => {
  const navigate = useNavigate();
  const isIslamic = useSelector(getIsIslamicBanking);

  const isValid = code.every(value => digitRegExp.test(value));
  const hasMaxAttemptsError = loginAttempt > MAX_ATTEMPT_ALLOWED;

  const codeMaxAttemptsError = attempts >= MAX_NUMBER_VALIDATION_ERRORS;

  const handleRedirect = () => {
    navigate(routes.comeBackLogin);
  };

  return (
    <StyledOTPForm islamic={isIslamic}>
      <ConfirmDialog
        title={"Maximum attempts exceeded"}
        isOpen={hasMaxAttemptsError}
        message={
          "You have exceeded the maximum number of OTP attempts. Please click continue to restart the journey."
        }
        confirmLabel="Continue"
        handleConfirm={handleRedirect}
      />
      <Formik initialValues={code} onSubmit={submitForm}>
        {() => (
          <FormikForm className={"form"} data-testid="otp-form">
            <div className="otpReseneLinkWrapper">
              {heading}
              <SectionTitleWithInfo
                className={"title"}
                title={title}
                info={info}
                smallInfo
                showInfoIcon
                otpType={otpType}
                data-testid="otp-title"
              />
              <div className={"otpInputWrapper"}>
                <Input
                  code={code}
                  onChange={setCode}
                  ref={otpRef}
                  disabled={codeMaxAttemptsError}
                />
              </div>

              {!codeMaxAttemptsError && verificationError && (
                <ErrorMessage classes={{ error: "error" }} error="Code verification failed." />
              )}
              {(codeMaxAttemptsError || maxServerAttemptsExceeded) && (
                <ErrorMessage
                  classes={{ error: "error" }}
                  error='You have exceeded the maximum number of OTP attempts. Please click the "Resend OTP" to generate a new OTP.'
                />
              )}

              <div>
                {/* OTP expires in 3:00 mins */}
                {/* <p className={classes.otpExpireMsg}>OTP expires in 3:00 mins</p> */}
                <span
                  onClick={handleSendNewCodeLinkClick}
                  className={cx("link", hasMaxAttemptsError && "linkDisabled")}
                >
                  Resend OTP
                </span>
              </div>
            </div>

            <Footer extraClasses={"oneElement"}>
              <SubmitButton
                disabled={!isValid || isPending || isGenerating || maxServerAttemptsExceeded}
                justify="flex-end"
                label={"Next"}
                submitButtonClassName={"submitButton"}
                data-testid="submit-button"
              />
            </Footer>
          </FormikForm>
        )}
      </Formik>
    </StyledOTPForm>
  );
};
